import { Box, Button, IconButton, Link, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CampaignIcon from "@mui/icons-material/Campaign";
import { useAnnouncementBanner } from "../hooks/useAnnouncementBanner";
import { UNIFICATION_ANNOUNCEMENT_URL } from "@constants";

export function UnificationAnnouncementBanner() {
  const { isVisible, handleDismiss } = useAnnouncementBanner();

  if (!isVisible) {
    return null;
  }

  return (
    <Box
      role="banner"
      aria-label="Unification announcement"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#E3F2FD",
        borderBottom: "0px solid #E3F2FD",
        px: 2,
        py: 1.5,
        width: "100%",
        boxSizing: "border-box",
        mt: -3,
        mb: 3,
      }}
    >
      {/* Left: icon + message */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flex: 1,
          minWidth: 0,
        }}
      >
        <CampaignIcon
          sx={{ color: "#1565C0", fontSize: "1.75rem", flexShrink: 0 }}
          aria-hidden="true"
        />
        <Typography variant="body2" sx={{ color: "#1A1A1A" }}>
          <Typography component="span" variant="body2" fontWeight="bold">
            Heads up!{" "}
          </Typography>
          SHI One and SHI.com are being unified to provide you with an improved
          experience with new features, single sign-on, and more. See the{" "}
          <Link
            href={UNIFICATION_ANNOUNCEMENT_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: "bold", color: "#1565C0" }}
          >
            full announcement
          </Link>{" "}
          to learn more...
        </Typography>
      </Box>

      {/* Right: Learn More button + close */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          flexShrink: 0,
          ml: 2,
        }}
      >
        <Button
          variant="text"
          size="small"
          href={UNIFICATION_ANNOUNCEMENT_URL}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "#1565C0",
            fontWeight: "bold",
            whiteSpace: "nowrap",
            letterSpacing: "0.05em",
          }}
        >
          Learn More
        </Button>
        <IconButton
          size="small"
          onClick={handleDismiss}
          aria-label="Close announcement banner"
          sx={{ color: "#616161" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}

